export default __webpack_public_path__ + "maps-guides-markers-annotations-view-1200-8c903dedd9c72c43b17cbfe537799ab9.webp";